/**
 *    Meeting rooms
 */

window.Tablesort = require('tablesort');
require('tablesort/src/sorts/tablesort.number');

(function ($) {
  Drupal.behaviors.meetingRooms = {
    attach(context, settings) {
      const isMobile = function () {
        if (Foundation.MediaQuery.current === 'small') {
          return true;
        }
        return false;
      };

      const changeTableToAccordionIfMobile = function () {
        if (isMobile()) {
          $('.vb-meeting-rooms').find('tbody tr').find('td:first-child').each((index, accordion) => {
            $(accordion)
              .attr({
                tabindex: '0',
                'aria-expanded': 'false',
                'aria-controls': $(accordion).data('aria-controls'),
                role: 'button',
              })
              .closest('.vb-meeting-rooms__row')
              .find('[data-iframe]')
              .attr('tabindex', '-1');
          });
        } else {
          $('.vb-meeting-rooms').find('tbody tr').find('td:first-child').each((index, accordion) => {
            $(accordion)
              .removeAttr('tabindex aria-expanded aria-controls role')
              .closest('.vb-meeting-rooms__row')
              .find('[data-iframe]')
              .removeAttr('tabindex');
          });
        }
      };

      // on init
      changeTableToAccordionIfMobile();

      // on resize
      $(window).on('changed.zf.mediaquery', () => {
        changeTableToAccordionIfMobile();
      });

      // https://codepen.io/jensgro/pres/cwjnq
      $('.vb-meeting-rooms').each(function () {
        const $wrapper = $(this);
        const $table = $wrapper.find('.vb-meeting-rooms__table');
        const trAcc = $table.find('tbody tr');
        const thHead = [];

        // generate mobile headlines array
        $table.find('thead th').each(function () {
          const headline = $(this).html();
          thHead.push(headline);

          // a11y
          $(this).on('keydown', function (event) {
            if (event.key === 'Enter') {
              $(this).trigger('click');
            }
          });
        });

        // append additional markup and attributes
        trAcc.each(function () {
          for (let i = 0; i < thHead.length; i++) {
            const $row = $(this).find('td').eq(i + 1);
            const sortValue = parseFloat($row.text().replace('.', '').replace(',', '.'));

            // add sorting value if a number
            if ($.isNumeric(sortValue)) {
              $row.attr('data-sort', sortValue);
            } else {
              $row.attr('data-sort', 0);
            }

            // add mobile headline
            $row.prepend(`<h3>${thHead[i + 1]}</h3>`);
          }
        });

        // append icon
        trAcc.find('td:first-child').append('<span class="icon-arrow-down"></span>');

        // toggle accordion
        trAcc.find('td:first-child').on('click keydown', function (event) {
          if (isMobile()) {
            if (event.type === 'click' || (event.type === 'keydown' && event.key === 'Enter')) {
              const $accordionRow = $(this).closest('tr');

              if ($accordionRow.hasClass('vb-active')) {
                $accordionRow.animate({
                  maxHeight: '67px',
                }, 200).removeClass('vb-active').find('.icon-arrow-down').removeClass('vb-active');
                $accordionRow.find('[data-iframe]').attr('tabindex', '-1');
                $(this).attr('aria-expanded', 'false');
              } else {
                $accordionRow.animate({
                  maxHeight: '1000px',
                }, 400).addClass('vb-active').find('.icon-arrow-down').addClass('vb-active');
                $accordionRow.find('[data-iframe]').attr('tabindex', '0');
                $(this).attr('aria-expanded', 'true');
              }
            }
          }
        });

        var $tbody = $table.find('tbody');
        var $tbody = $table.find('tbody');
        const $tbodyRows = $tbody.find('tr');
        const $buttonShowMore = $wrapper.find('.vb-meeting-rooms__button--show-more');

        if ($tbodyRows.length > 4) {
          // hide 'meeting rooms'
          $wrapper.addClass('vb-hide-items');
        }

        // click 'show more' button
        $buttonShowMore.on('click', () => {
          // show all 'meeting room' items
          $wrapper.removeClass('vb-hide-items');
        });

        // init 'table sorter' plugin
        new Tablesort($table[0]);

        // write sort direction on table
        $table[0].addEventListener('afterSort', () => {
          $wrapper.attr('data-sort-direction', $table.find('[aria-sort]').attr('aria-sort'));
        });

        // init mobile sorting layer
        meetingRoomsMobileSorting($wrapper, thHead);
      });

      function meetingRoomsPanoroma() {
        const $panoramaGallery = $('.vb-meeting-rooms');

        // init panorama gallery
        $panoramaGallery.lightGallery({
          thumbnail: false,
          download: false,
          closable: false,
          hideBarsDelay: 10000000,
          selector: '.vb-meeting-rooms__link',
        });

        $panoramaGallery.on('onAfterOpen.lg', (e) => {
          // a11y
          $('.lg-close')
            .attr({
              'aria-label': Drupal.t('Close'),
              tabindex: '0',
              role: 'button',
            })
            .append('<span aria-hidden="true" class="lg-close__icon"></span>')
            .on('keydown', function (event) {
              if (event.key === 'Enter') {
                $(this).click();
              }
            })
            .trigger('focus');

          // focus trap
          Foundation.Keyboard.trapFocus($('.lg-outer'));
        });
      }

      function meetingRoomsMobileSorting($wrapper, thHead) {
        const $table = $wrapper.find('.vb-meeting-rooms__table');
        const buttonTextToggle = $wrapper.data('button-toggle');
        const buttonTextOk = $wrapper.data('button-ok');
        const randomId = Math.floor(Math.random() * 100000);
        let markup = '<div class="vb-meeting-rooms-mobile-sorting">'
                    + `<button class="vb-meeting-rooms-mobile-sorting__button vb-meeting-rooms-mobile-sorting__button--toggle" type="button">${buttonTextToggle}</button>`
                    + `<div class="vb-meeting-rooms-mobile-sorting__layer" aria-modal="true" role="dialog" aria-labelledby="vb-meeting-rooms-mobile-sorting__title--${randomId}">`
                    + '<div class="vb-meeting-rooms-mobile-sorting__header">'
                    + `<h3 class="vb-meeting-rooms-mobile-sorting__title" id="vb-meeting-rooms-mobile-sorting__title--${randomId}">${buttonTextToggle}</h3>`
                    + `<button type="button" class="vb-button vb-button--link vb-button--round vb-button--small vb-meeting-rooms-mobile-sorting__button vb-meeting-rooms-mobile-sorting__button--close" aria-label="${Drupal.t('Close')}">`
                    + '<span class="icon-close"></span>'
                    + '</button>' // mit Drupal t()-Funktion übersetzbar machen
                    + '</div>'
                    + '<div class="vb-meeting-rooms-mobile-sorting__body">'
                    + '<ul class="vb-meeting-rooms-mobile-sorting__items">';
        for (let i = 0; i < thHead.length; i++) {
          markup += `<li class="vb-meeting-rooms-mobile-sorting__item" role="button" tabindex="0">${thHead[i]}</li>`;
        }
        markup
                    += '</ul>'
                    + '</div>'
                    + '<div class="vb-meeting-rooms-mobile-sorting__footer">'
                    + `<button type="button" class="vb-button vb-button--secondary vb-button--small vb-meeting-rooms-mobile-sorting__button vb-meeting-rooms-mobile-sorting__button--okay">${buttonTextOk}</button>`
                    + '</div>'
                    + '</div>'
                    + '</div>';

        // append mobile sort layer after table
        $table.after(markup);

        // open/close the mobile sort layer
        $wrapper.on('click', '.vb-meeting-rooms-mobile-sorting__button', function () {
          $(this).closest('.vb-meeting-rooms-mobile-sorting').toggleClass('vb-active');
          // focus trap
          Foundation.Keyboard.trapFocus($(this).closest('.vb-meeting-rooms-mobile-sorting').find('.vb-meeting-rooms-mobile-sorting__layer'));
        });

        // click item and trigger sorting
        $wrapper.on('click keydown', '.vb-meeting-rooms-mobile-sorting__item', function (event) {
          if (event.type === 'click' || (event.type === 'keydown' && event.key === 'Enter')) {
            const $item = $(this);
            const index = $item.index();
            // trigger click
            $table.find(`thead th:eq(${index})`).trigger('click');

            $item
              .addClass('vb-active')
              .siblings()
              .removeClass('vb-active');
          }
        });
      }

      // init media gallery for panoramas
      meetingRoomsPanoroma();
    },
  };
}(jQuery));

// end of meeting-rooms.js
